import { Box, Spinner, Text } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import QuickbookButton from 'assets/images/QuickBook_Button/C2QB_green_btn_med_default.svg?react';
import QuickbookButtonHovered from 'assets/images/QuickBook_Button/C2QB_green_btn_med_hover.svg?react';
import { FormikCheckbox } from 'components/Formik';
import {
  useSetBillableQuickbookDesktop,
  IQuickbookDesktopSetBillable,
} from 'hooks/integrations/useSetBillableQuickbookDesktop';

import { initialConnectValue } from './schema';

interface IConnect {
  onConnect: () => void;
}

const Connect = ({ onConnect }: IConnect) => {
  const [isHovered, setIsHovered] = useState(false);

  const { status: connectStatus, mutateAsync: connectMutateAsync } = useSetBillableQuickbookDesktop();

  const { t } = useTranslation(['integrations']);

  const handleFormSubmit = async (values: typeof initialConnectValue) => {
    const postData: IQuickbookDesktopSetBillable = {
      is_billable: values.is_billing.length ? 1 : 0,
    };
    connectMutateAsync(postData).then(() => {
      onConnect();
    });
  };

  return (
    <Box boxShadow="0 0 5px 0 #e1e1e1" borderRadius="5px" padding="10px 20px 20px 20px">
      <Text fontSize="sm" mb={4}>
        {t('integrations:quickbooksDesktop.invoiceFeatures')}
      </Text>

      <Formik initialValues={initialConnectValue} enableReinitialize onSubmit={handleFormSubmit}>
        {() => (
          <Form noValidate>
            <Box display="flex">
              <FormikCheckbox
                options={[{ label: t('integrations:quickbooksDesktop.sendTimeAsBillable'), value: '1' }]}
                name="is_billing"
              />
            </Box>
            <Box textAlign="right">
              <button
                type="submit"
                style={{ marginLeft: 'auto', position: 'relative' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                disabled={connectStatus === 'loading'}
              >
                {/* Must use QuickBook provided image as Button as to comply with QuickBook rules.
            https://developer.intuit.com/app/developer/qbo/docs/go-live/list-on-the-app-store/naming-and-logo-guidelines*/}
                {isHovered ? <QuickbookButtonHovered /> : <QuickbookButton />}
                {connectStatus === 'loading' && (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    as="span"
                    position="absolute"
                    width="100%"
                    height="100%"
                    top="0"
                    left="0"
                    background="#2CA01C"
                  >
                    <Spinner size="sm" emptyColor="gray.200" color="success.500" thickness="3px" />
                  </Box>
                )}
              </button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
export default Connect;
